import {
  ColorItem,
  ConfigurableProduct,
  Maybe
} from "@/types/graphql.prod"
import {
  useMemo,
  useState
} from "react"

export const useGetImage = ({
  item
}: {
  item: ConfigurableProduct
}) => {
  const [selectedColor, setSelectedColor] = useState<Maybe<ColorItem> | null>()

  const colorOptions = useMemo(() => {
    if (item.show_colors?.items?.length) {
      return item.show_colors.items
    }
 
    return []
  }, [item])

  const productImage = useMemo(() => {
    if (selectedColor) {
      return selectedColor?.image
    }
 
    if ((item?.__typename as any) === "SimpleProduct") {
      return item?.image?.url
    }
 
    // cart 页面
    return item?.small_image?.url
  }, [item, selectedColor])

  const hoverImage = useMemo(() => {
    if (selectedColor) {
      return selectedColor?.hover_image
    } else if (item.__typename === "ConfigurableProduct") {
      return item.hover_image
    }
 
    if (colorOptions) {
      const selectedOption = colorOptions.find((temp: any) => temp.uid === selectedColor)

      if (selectedOption) {
        // 拼接图片字符串
        const imageUrl = `media/catalog/product/product_image/${item.sku}/${
          item.sku
        }-${selectedOption?.label?.replace(" ", "-")}(2)-692x1016.jpg`

        return imageUrl
      }
    }

    return item.hover_image
        
  }, [colorOptions, item, selectedColor])

  return {
    productImage,
    hoverImage,
    selectedColor, 
    setSelectedColor
  }
}
